import http from './api'

const route = '/movimentacaoleite/'

export default {
    listarMovimentacao: (anoMovimentacao, chaveativacao) => {
        return http.post(route + 'buscarmovimentacao', {
            anoMovimentacao: anoMovimentacao,
            chaveativacao: chaveativacao,
        })
    },
    listarLaticinios: (chaveativacao) => (
        http.post(route + 'listar_empresas', { chaveativacao: chaveativacao })
    ),
    listarItensNotaFiscal: (idNotaFiscal) => {
        return http.post(route + 'listar_itens_nota_fiscal', {
            notafiscal_id: idNotaFiscal,
        })
    },
}
